<template>
  <div class="">
    <div class="flex justify-center">
      <div>
        <div class="font-bold flex justify-center mt-4 mb-2 text-2xl">
          {{ $t("i18nCommon.Category") }}
        </div>
        <div class="menus">
          <a-button
            class="menu-category cursor-pointer flex justify-center items-center mb-4 font-bold"
            type="primary"
            @click="menuClick(category)"
            :key="index"
            :class="menuActive.id === category.id ? 'menu-category-active' : ''"
            v-for="(category, index) in categories"
          >
            {{ category.display }}
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CategoryMenuDetail",
  data() {
    return {
      categories: [],
      menuActive: {},
    };
  },
  created() {
    const me = this;
    let lang = me.$commonFunc.getLanguageToCached();
    me.$i18n.locale = lang;
    this.initDataStatic();
    //check router
    me.checkRouter();
    me.$emitter.on("LoadLanguage", me.initDataStatic);
  },
  beforeDestroy() {
    this.$emitter.off("LoadLanguage", this.initDataStatic);
  },
  methods: {
    checkRouter() {
      const me = this;
      const routePath = me.$route.path;
      const menu = me.categories.find((menu) => menu.router === routePath);
      if (menu) {
        me.menuActive = menu;
      } else {
        console.error("Invalid route:", routePath);
      }
    },
    initDataStatic() {
      const me = this;
      me.categories = [
        {
          id: 1,
          display: me.$t("i18nCommon.Product"),
          router: "/create-product",
        },
        {
          id: 2,
          display: me.$t("i18nCommon.Category"),
          router: "/create-category",
        },
        {
          id: 3,
          display: me.$t("i18nCommon.Supplier"),
          router: "/create-supplier",
        },
        {
          id: 4,
          display: me.$t("i18nCommon.Order"),
          router: "/create-order",
        },
        {
          id: 5,
          display: me.$t("i18nCommon.Customer"),
          router: "/create-customer",
        },
        // {
        //   id: 6,
        //   display: me.$t("i18nCommon.Shipper"),
        //   router: "/create-shipper",
        // },
        {
          id: 7,
          display: me.$t("i18nCommon.SaleEmployee"),
          router: "/create-employee",
        },
        {
          id: 8,
          display: me.$t("i18nCommon.AddItem"),
          router: "/create-item",
        },
        {
          id: 9,
          display: me.$t("i18nCommon.User"),
          router: "/create-user",
        },
        {
          id: 10,
          display: me.$t("i18nCommon.Group"),
          router: "/create-group",
        },
      ];
    },
    menuClick(menu) {
      const me = this;
      me.menuActive = menu;
      if (me.menuActive) {
        me.$router.push(menu.router);
      }

      me.$emit("afterChange", menu);
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-category {
  height: 36px;
  width: 200px;
  border-radius: 8px;
}

.menu-category-active {
  background: #fa3900;
  color: #fff;

  &:hover {
    background: #fa3900;
  }
}
</style>
